// extracted by mini-css-extract-plugin
module.exports = {"markdownWrap":"markdown_markdownWrap__gpN9j","customFont":"markdown_customFont__E0xXk","disableMargin":"markdown_disableMargin__lcYwh"};